module.exports = __webpack_public_path__ + "static/img/icons_purchases_blue.c4733a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_purchases_blue.svg
// module id = MGuV
// module chunks = 1